import { render, staticRenderFns } from "./Bss.vue?vue&type=template&id=b68a6dfc&scoped=true"
import script from "./Bss.vue?vue&type=script&lang=js"
export * from "./Bss.vue?vue&type=script&lang=js"
import style0 from "./Bss.vue?vue&type=style&index=0&id=b68a6dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68a6dfc",
  null
  
)

export default component.exports